/**
 * Fusion profonde des objets de traduction (partiels + base).
 */
export function deepMerge(target, source) {
  const out = { ...target };
  Object.keys(source || {}).forEach((key) => {
    if (
      source[key] &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key]) &&
      typeof out[key] === 'object' &&
      !Array.isArray(out[key])
    ) {
      out[key] = deepMerge(out[key], source[key]);
    } else {
      out[key] = source[key];
    }
  });
  return out;
}

export function mergeLocaleChain(...partials) {
  return partials.reduce((acc, part) => deepMerge(acc, part), {});
}
